(function () {
  if (window.zenGa4Ecommerce && window.zenGa4Ecommerce.initialized) return;

  var state = {
    initialized: true,
    viewItemPushed: false,
    beginCheckoutPushed: false,
  };

  window.zenGa4Ecommerce = state;
  window.dataLayer = window.dataLayer || [];

  function parsePayload(element) {
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  function pushEvent(eventName, ecommerce) {
    if (!ecommerce || !Array.isArray(ecommerce.items) || ecommerce.items.length === 0) return;

    window.dataLayer.push({
      event: eventName,
      ecommerce: ecommerce,
    });
  }

  function pushViewItem() {
    if (state.viewItemPushed) return;

    var payload = parsePayload(document.querySelector('[data-zen-ga4-view-item]'));
    if (!payload) return;

    state.viewItemPushed = true;
    pushEvent('view_item', payload);
  }

  function getCheckoutPayload(submitter) {
    var container = submitter.closest('cart-notification, cart-drawer, .zen-cart') || document;
    var payloadElements = container.querySelectorAll('[data-zen-ga4-begin-checkout]');
    var payloadElement = payloadElements[payloadElements.length - 1];
    var payload = parsePayload(payloadElement);

    if (!payload) return null;

    var form = submitter.form;
    var quantityInputs = form ? form.querySelectorAll('input[name="updates[]"]') : [];

    if (quantityInputs.length === payload.items.length) {
      var quantityChanged = false;

      payload.items = payload.items
        .map(function (item, index) {
          var quantity = Math.max(0, parseInt(quantityInputs[index].value || '0', 10));
          if (quantity !== item.quantity) quantityChanged = true;

          return {
            item_id: item.item_id,
            item_name: item.item_name,
            price: item.price,
            quantity: quantity,
          };
        })
        .filter(function (item) {
          return item.quantity > 0;
        });

      if (quantityChanged) {
        payload.value = Number(
          payload.items
            .reduce(function (total, item) {
              return total + item.price * item.quantity;
            }, 0)
            .toFixed(2)
        );
      }
    }

    return payload;
  }

  function handleCheckoutSubmit(event) {
    var submitter = event.submitter;

    if (
      state.beginCheckoutPushed ||
      !submitter ||
      submitter.getAttribute('name') !== 'checkout'
    ) {
      return;
    }

    var payload = getCheckoutPayload(submitter);
    if (!payload) return;

    state.beginCheckoutPushed = true;
    pushEvent('begin_checkout', payload);
  }

  document.addEventListener('submit', handleCheckoutSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushViewItem, { once: true });
  } else {
    pushViewItem();
  }
})();
